import { render, staticRenderFns } from "./PainelItem.vue?vue&type=template&id=4300b8c7&scoped=true"
import script from "./PainelItem.vue?vue&type=script&lang=js"
export * from "./PainelItem.vue?vue&type=script&lang=js"
import style0 from "./PainelItem.vue?vue&type=style&index=0&id=4300b8c7&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4300b8c7",
  null
  
)

export default component.exports